import {Theme} from '@mui/material/styles';

export default function PickersLayout(_theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiDialogActions-root': {
            padding: '8px',
            justifyContent: 'flex-end',
          },
        },
      },
    },
  };
}
